import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { UserProfile } from '../../UserProfile/UserProfile'
import { Container, SubMenuIcon } from './styles'

type Props = {
  closeMenu?: () => void
}

export const ProfileAvatar = (props: Props) => {
  const { closeMenu } = props

  const handleClick = () => {
    closeMenu?.()
    trackInternalEvent('click_career_profile')
  }

  return (
    <Link to="/career-profile/profile" onClick={handleClick}>
      <Container>
        <UserProfile />
        <SubMenuIcon />
      </Container>
    </Link>
  )
}
